import { ApiAddress } from '../api/api-types/address.api';
import { Address } from '../api/app-types/address.app';

export const addressMock: Address = {
	id: 1,
	postalCodeAndCity: '12345 Test City',
	streetAndHouseNumber: 'Test Street 123',
	anonym: '',
	identifier: '',
	soundexStreet: '',
};

export const apiAddressMock: ApiAddress = {
	id: 1,
	postalCodeAndCity: '12345 Test City',
	streetAndHouseNumber: 'Test Street 123',
	anonym: '',
	identifier: '',
	soundexStreet: '',
};
